import React from "react";
import IconMarker from "assets/svg/map-marker.svg";
import IconRetinaMarker from "assets/svg/map-marker.svg";
import useCustomMarker from "hooks/leaflet/useCustomMarker";
import { Popup, useMap } from "react-leaflet";
import { Marker } from "leaflet";

import "leaflet/dist/leaflet.css";

interface ILocationMarker {
  draggable?: boolean;
  position: [number, number];
  setPosition: (lat: number, lng: number) => void;
}

const LocationMarker = React.forwardRef(
  (props: ILocationMarker, forwardRef) => {
    const map = useMap();
    const markerRef = React.useRef<Marker>(null);
    const { draggable, position, setPosition } = props;
    const { CustomMarker } = useCustomMarker(
      IconMarker,
      IconRetinaMarker,
      draggable
    );

    React.useImperativeHandle(forwardRef, () => markerRef.current as Marker);

    const onDragEnd = React.useMemo(
      () => () => {
        const marker = markerRef.current;
        const position = marker.getLatLng();
        if (markerRef.current) setPosition(position.lat, position.lng);
      },

      // eslint-disable-next-line
      []
    );

    React.useEffect(() => {
      map.locate().on("locationfound", (e) => {
        setPosition(e.latlng.lat, e.latlng.lng);
        map.flyTo(e.latlng, map.getZoom());
      });

      // eslint-disable-next-line
    }, [map]);

    return position === null ? null : (
      <CustomMarker
        position={position}
        ref={markerRef}
        eventHandlers={{
          dragend: onDragEnd,
        }}
      >
        <Popup>The location is here</Popup>
      </CustomMarker>
    );
  }
);

export default LocationMarker;
